/**
 * Tiny module-level store that bridges the front-page interest filters
 * (the supertag tiles + category checkboxes in SupertagPicker) to the chat
 * assistant.
 *
 * The assistant is mounted in the root layout (app/layout.jsx), i.e. OUTSIDE
 * the React context that holds the filter state (DestinationFilter /
 * SupertagProvider live inside the page subtree), so it cannot read the
 * selections through context. The picker writes the current selection here and
 * the chatbot reads the snapshot at send time — that is the only moment it is
 * needed, so this is intentionally a plain mutable store, not React state.
 *
 * Values are resolved, human-readable titles (e.g. "Natur", "Vandring"), ready
 * to drop into the model prompt.
 */

/** @type {{ supertags: string[], categories: string[] }} */
let snapshot = { supertags: [], categories: [] };

export function setDestinationContext(next) {
  snapshot = {
    supertags: next?.supertags ?? [],
    categories: next?.categories ?? []
  };
}

export function getDestinationContext() {
  return snapshot;
}
